import React, { useState, useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import UpsertModal from "../Modals/upsert"
import toastr from "toastr"
import * as moment from "moment"
import * as Http from "utils/http.helper"
import OrderDetails from "../Modals/order_details"
import config from "config"
import {
  Table,
  Tag,
  Button,
  Select,
  Tooltip,
  Card,
  Form,
  Typography,
  Input,
  Popconfirm,
} from "antd"
import {
  SearchOutlined,
  ClearOutlined,
  EyeOutlined,
  AppstoreAddOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  UploadOutlined,
  ClockCircleOutlined,
  EditOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons"
import {
  BrowserRouter as Router,
  useLocation,
  useNavigate,
} from "react-router-dom"
const { Option } = Select
const { Paragraph } = Typography

import "toastr/build/toastr.min.css"
const today = new Date()

const css = `
#order-list td{
  vertical-align: middle;
}
tr{ cursor:pointer }
 .multipleRow, .multipleRow .ant-table-cell-fix-right{
  background:#c2dafe!important;
}
.multipleRow td:first-child
{
  font-weight:bold
}
.ant-table-row-level-1 .ant-table-cell:first-child,
.ant-table-row-level-2 .ant-table-celll:first-child,
.ant-table-row-level-3 .ant-table-celll:first-child,
.ant-table-row-level-4 .ant-table-celll:first-child,
.ant-table-row-level-5 .ant-table-celll:first-child,
.ant-table-row-level-6 .ant-table-celll:first-child,
.ant-table-row-level-7 .ant-table-celll:first-child,
.ant-table-row-level-8 .ant-table-celll:first-child,
.ant-table-row-level-9 .ant-table-celll:first-child,
.ant-table-row-level-10 .ant-table-celll:first-child{
  font-weight:bold
}
.ant-table-cell-row-hover,
.ant-table-cell-row-hover.ant-table-cell-fix-right{
  background:#dddddd!important;
}
.ant-table-cell.ant-table-cell-with-append .ant-table-row-expand-icon.ant-table-row-expand-icon-spaced{
  background:red
}
.multipleRow:hover .ant-table-cell-row-hover{
  background:#c2dafe!important;

}
@page
{
    size: auto;
    margin: 25mm 5mm 25mm 5mm;
}`
const orderStatus = [
  {
    value: 10,
    label: "New Order",
  },
  {
    value: 20,
    label: "Production Ready",
  },
  {
    value: 30,
    label: "Production",
  },
  {
    value: 40,
    label: "Pdf Printed",
  },
  {
    value: 50,
    label: "Completed",
  },
  {
    value: 60,
    label: "Shipped",
  },
  {
    value: 70,
    label: "Waiting For Design",
  },
  {
    value: 80,
    label: "Canceled",
  },
]
const OrderList = () => {
  document.title = "Apparel List | EASY JET CONNECT"
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state
  const [form] = Form.useForm()
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false)
  const [companyDataList, setCompanyDataList] = useState([])
  const [recordNameList, setRecordNameList] = useState([])
  const [showRecordName, setShowRecordName] = useState("")
  const [isReadyRecord, setIsReadyRecord] = useState(false)
  const [selectedRecordName, setSelectedRecordName] = useState(null)
  const [maxDate, setMaxDate] = useState(null)
  const [orderDetails, setOrderDetails] = useState({
    show: false,
    data: null,
  })
  const [upsertModal, setUpsertModal] = useState({
    show: false,
    data: null,
    recordName: "",
  })
  const [tableParams, setTableParams] = useState({
    current: 0,
    pageSize: 0,
    total: 0,
  })

  const [haveOrderBefore, setHaveOrderBefore] = useState(true)
  const getHaveOrderBefore = () => {
    Http.get(`api/orders/HaveOrderBefore?categoryId=1`)
      .then(res => {
        if (res?.success) {
          setHaveOrderBefore(!res.data)
        }
      })
      .catch(function (error) {})
  }

  useEffect(() => {
    getHaveOrderBefore()
  }, [])

  useEffect(() => {
    if (state?.orderId) {
      form.setFieldsValue({
        orderId: state?.orderId,
      })
    }
  }, [])

  const getTableData = (pagination, recName) => {
    if (form.validateFields()) {
      setLoading(true)
      const formValues = form.getFieldValue()

      let findRecord = recordNameList.find(
        x => x.value === formValues.recordName
      )

      if (findRecord || recName) {
        setProducts([])

        const page = pagination?.current || 1
        const limit = pagination?.pageSize || 10
        const orderName = findRecord ? findRecord.label : recName
        const search = formValues.orderId ? "&search=" + formValues.orderId : ""
        const companyId = formValues.companyId

        const customerPart = companyId ? `&customerId=${companyId}` : ""

        const isMultiple = findRecord?.source === "multiple"
        const endpoint = isMultiple
          ? `api/orders/GetMultipleEngravingApparelOrders?pageNumber=${page}&limit=${limit}&categoryIds=1${customerPart}&orderRecordName=${orderName}${search}`
          : `api/orders/GetMultipleEngravingApparelOrders?pageNumber=${page}&limit=${limit}&categoryIds=1${customerPart}&orderRecordName=${orderName}${search}`

        Http.get(endpoint)
          .then(res => {
            if (res?.success) {
              const orders = res?.data?.data?.orders || []
              if (orders.length > 0) {
                let maxDate = null
                orders.forEach(item => {
                  item.key = item.id
                  item?.children?.length === 0 && delete item.children
                  const addDate = new Date(item.addDate)
                  if (maxDate === null || addDate > maxDate) {
                    maxDate = addDate
                  }
                })

                let newMaxDate = new Date(maxDate)
                setMaxDate(moment(newMaxDate).format("DD/MMM/YYYY"))

                setProducts(orders)
                setTableParams({
                  current: page,
                  pageSize: limit,
                  total: res?.data?.totalItems || tableParams.total,
                })
              } else {
                setProducts([])
                setTableParams({
                  current: page,
                  pageSize: limit,
                  total: 0,
                })
              }
            } else {
              setProducts([])
              setTableParams({
                current: 1,
                pageSize: 10,
                total: 0,
              })
            }
            setLoading(false)
          })
          .catch(error => {
            setLoading(false)
            toastr.error(error.response?.Message)
          })
      } else {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    if (
      selectedRecordName?.value &&
      JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2
    ) {
      Http.get(
        `api/orders/IsReadyProductionRecordName?recordName=${selectedRecordName.label}&categoryId=1`
      ).then(res => {
        setIsReadyRecord(res.data.isReady)
      })
    }
  }, [selectedRecordName])

  const getCompanyData = () => {
    Http.get("api/companies/getAllCustomers?categoryId=1").then(res => {
      if (res?.success) {
        let arr = [{ label: "All", value: "" }]
        res?.data.map(item => {
          arr.push({ label: item.name, value: item.id })
        })
        setCompanyDataList(arr)
      }
    })
  }

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("authUserV0")).roleId === 1 ||
      JSON.parse(localStorage.getItem("authUserV0")).roleId === 7
    ) {
      getCompanyData()
    }
  }, [])

  const getRecordsName = val => {
    const formValues = form.getFieldValue()
    let selectedCompany = formValues.companyId
    // Eğer ALL seçiliyse, tüm müşteri id’lerini array olarak al:
    let companyIds = []
    if (selectedCompany === "") {
      companyIds = companyDataList.filter(x => x.value !== "").map(x => x.value)
    } else if (selectedCompany) {
      companyIds = [selectedCompany]
    }
    // companyId parametrelerini query string olarak hazırla
    const companyIdParams = companyIds
      .map(id => `companyIds=${encodeURIComponent(id)}`)
      .join("&")
    const categoryIdParam = "categoryId=1"
    setShowRecordName(formValues?.recordName ? false : true)
    Promise.all([
      Http.get(
        `api/orders/GetMultipleRecordNames?${companyIdParams}&${categoryIdParam}`
      ),
    ])
      .then(([res1, res2]) => {
        const combined = []
        const seen = new Set()

        const addUnique = (data, source) => {
          data.forEach(item => {
            if (!seen.has(item.name)) {
              seen.add(item.name)
              combined.push({
                label: item.name,
                value: item.id,
                source,
              })
            }
          })
        }

        if (res1?.data?.length) addUnique(res1.data, "single")
        if (res2?.data?.length) addUnique(res2.data, "multiple")

        setRecordNameList(combined)

        if (
          authUser?.roleId === 2 ||
          authUser?.roleId === 7 ||
          authUser?.roleId === 1
        ) {
          if (!state?.orderId && combined.length > 0) {
            form.setFieldsValue({
              recordName: combined[0].value,
            })
            setShowRecordName(combined[0].label)
            setSelectedRecordName(combined[0])
            getTableData(null, combined[0].label)
          }
        }
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("authUserV0"))?.roleId !== 1 &&
      JSON.parse(localStorage.getItem("authUserV0"))?.companyId
    ) {
      getRecordsName(JSON.parse(localStorage.getItem("authUserV0"))?.companyId)
    }
  }, [])

  const handleChangeStatus = (id, statusCode, sku, orderId) => {
    setLoading(true)
    Http.post("api/orders/ChangeOrderStatus", {
      orderId: id,
      status: statusCode,
    })
      .then(res => {
        if (res.success) {
          toastr.success(
            `${orderId} order number and ${sku} sku number, order status has been update`
          )
          statusCode === 80 && getTableData()
        } else {
          setProducts([])
          getTableData({
            current: tableParams.current,
            pageSize: tableParams.pageSize,
          })
          toastr.error(
            `${orderId} order number and ${sku} sku number, order status update process failed`
          )
        }
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
        setProducts([])
        getTableData({
          current: tableParams.current,
          pageSize: tableParams.pageSize,
        })
        toastr.error("Status update process fail")
      })
  }

  const handleTableChange = pagination => {
    setLoading(true)
    setTableParams({
      current: pagination.current,
      pageSize: pagination.pageSize,
      total: tableParams.total,
    })
    if (
      tableParams.current !== pagination.current ||
      tableParams.pageSize !== pagination.pageSize
    ) {
      getTableData({
        current: pagination.current,
        pageSize: pagination.pageSize,
      })
    }
  }

  const onMoveWaitingList = values => {
    Http.post("api/orders/moveWaitingForDesign", {
      categoryId: 1,
      orderId: values.id,
    })
      .then(res => {
        if (res.success) {
          toastr.success(
            `${values.sku} sku, order has been moved to waiting for design list.`
          )
          getTableData()
        } else {
          getTableData()
          toastr.error(
            `${values.sku} sku, order could not be moved to waiting for design list. `
          )
        }
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
        getTableData()
      })
  }

  const columns = [
    {
      title: "Sku",
      dataIndex: "sku",
      key: "sku",
      width: 150,
      render: value => {
        return <Paragraph copyable>{value}</Paragraph>
      },
    },
    {
      title: "Order No",
      dataIndex: "orderId",
      key: "orderId",
      render: value => {
        return <Paragraph copyable>{value}</Paragraph>
      },
    },
    {
      title: "Quant.",
      dataIndex: "quantity",
      key: 3,
      width: 80,
    },
    {
      title: "Style",
      dataIndex: "style",
      key: 4,
    },
    {
      title: "Size",
      dataIndex: "size",
      key: 5,
    },
    {
      title: "Color",
      dataIndex: "color",
      key: 6,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: 7,
      render: (_, row) => {
        return row.price ? row.price + " $" : ""
      },
    },
    {
      title: "Personalization",
      dataIndex: "personalization",
      key: 8,
      width: 130,
      render: (_, row) => {
        if (row.hasPersonalization) {
          return (
            <Tooltip placement="top" title={row.personalization}>
              <div className="tooltip_table">
                {row?.personalization.length > 12
                  ? `${row?.personalization.substring(0, 12)}...`
                  : row?.personalization}
              </div>
            </Tooltip>
          )
        } else {
          return ""
        }
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: 9,
      width: "150px",
      render: (_, row) => {
        if (
          JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2 &&
          row.status < 30
        ) {
          return (
            <Select
              style={{
                width: "100%",
              }}
              defaultValue={row?.status}
              disabled={!row?.hasImages || row.status > 20}
              onChange={e =>
                handleChangeStatus(row.id, e, row.sku, row.orderId)
              }
            >
              {orderStatus.map((item, index) => {
                if (item.value < row.status + 20 && item.value < 30) {
                  return (
                    <Option key={index} value={item.value}>
                      {item.label}
                    </Option>
                  )
                }
              })}
            </Select>
          )
        } else {
          return (
            <Tag
              color={
                row.status === 10
                  ? "#28A745"
                  : row.status === 20
                  ? "#FFC107"
                  : row.status === 30
                  ? "#007BFF"
                  : row.status === 40
                  ? "#6F42C1"
                  : row.status === 50
                  ? "#6C757D"
                  : "#17A2B8"
              }
              key={row.id}
              style={{
                width: "100%",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              {orderStatus.find(x => x.value === row.status)?.label}
            </Tag>
          )
        }
      },
    },
    {
      title: "Name Surname",
      dataIndex: "nameSurname",
      key: 10,
      render: (_, row) => {
        return row?.shipmentDetail?.nameSurname
      },
    },
    {
      title: "Sale Date",
      dataIndex: "saleDate",
      key: "saleDate",
      key: 9,
      render: value => {
        return moment(new Date(value)).format("DD MMM YYYY")
      },
    },
    {
      title: "Has Image",
      dataIndex: "hasImages",
      key: "hasImages",
      align: "center",
      render: value => {
        return value ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: 20 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: 20 }} />
        )
      },
    },
    {
      title: " ",
      key: "action",
      hidden: JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 7,
      width:
        JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2 ? 100 : 80,
      render: (_, record) => {
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ columnGap: 10 }}
          >
            {/* {JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2 &&
              !record.hasImages && (
                <Tooltip placement="top" title="Edit Order">
                  <Button
                    type="button"
                    className="btn btn_primary d-flex align-items-center justify-content-center"
                    icon={<EditOutlined />}
                    onClick={() => {
                      setUpsertModal({
                        show: true,
                        data: record,
                        recordName: showRecordName,
                      })
                    }}
                  />
                </Tooltip>
              )} */}
            {record.hasImages && (
              <Tooltip placement="top" title="Show Design">
                <Button
                  className="btn btn_success d-flex align-items-center justify-content-center"
                  icon={<EyeOutlined />}
                  onClick={() => setOrderDetails({ show: true, data: record })}
                />
              </Tooltip>
            )}

            {JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2 && (
              <Tooltip placement="top" title="Upload Design">
                <Button
                  className="btn btn_tertiary d-flex align-items-center justify-content-center"
                  icon={<UploadOutlined />}
                  disabled={record.status > 20}
                  onClick={() => {
                    navigate(`/apparel-design-upload`, {
                      state: record,
                    })
                  }}
                />
              </Tooltip>
            )}

            {(JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 1 ||
              JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2) &&
              !record.hasImages && (
                <Tooltip placement="top" title="Move Waiting For Design">
                  <Popconfirm
                    title="Attention!"
                    description={
                      <>
                        Are you sure you want to move order number <br />{" "}
                        <span style={{ fontWeight: "700" }}>
                          {record.orderId}
                        </span>{" "}
                        to the design waiting list?
                      </>
                    }
                    onConfirm={() => {
                      onMoveWaitingList(record)
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="button"
                      className="btn btn_secondary d-flex align-items-center justify-content-center"
                      icon={<ClockCircleOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>
              )}

            {(JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 1 ||
              JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2) &&
              record.status < 30 && (
                <Tooltip placement="top" title="Cancel Order">
                  <Popconfirm
                    title="Attention!"
                    description="Are you sure you want to cancel the order?"
                    onConfirm={() => {
                      handleChangeStatus(
                        record.id,
                        80,
                        record.sku,
                        record.orderId
                      )
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="button"
                      className="btn btn_quinary d-flex align-items-center justify-content-center"
                      icon={<CloseCircleOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>
              )}
          </div>
        )
      },
    },
  ].filter(item => !item.hidden)

  const getImages = () => {
    setLoading(true)
    const { recordName, companyId } = form.getFieldValue()
    let customerIds = []
    if (companyId === "") {
      customerIds = companyDataList
        .filter(x => x.value !== "")
        .map(x => x.value)
    } else if (companyId) {
      customerIds = [companyId]
    }
    const findCompany = companyDataList.find(x => x.value === companyId)
    const findRecord = recordNameList.find(x => x.value === recordName)
    const categoryIds = [1]
    try {
      fetch(`${config.apiUrl}/api/orders/DownloadMultiplePdf`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          orderRecordId: recordName ? Number(recordName) : null,
          customerIds: customerIds.map(Number),
          categoryIds: categoryIds.map(Number),
        }),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok")
          }
          return response.blob()
        })
        .then(blob => {
          const downloadUrl = window.URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = downloadUrl
          link.download = `${findRecord.label} ${findCompany.label} ${moment(
            new Date()
          ).format("DD.MM.YYYY HH.mm.ss")}.pdf`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          getTableData()
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        })
    } catch (error) {
      setLoading(false)
    }
  }

  const getAllImages = () => {
    const { recordName, companyId } = form.getFieldValue()

    setLoading(true)
    fetch(`${config.apiUrl}/api/orders/DownloadMixMultipleFiles`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        recordNameId: recordName,
        categoryId: 1,
        customerId: companyId ? Number(companyId) : null,
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.blob()
      })
      .then(blob => {
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = downloadUrl
        link.download = `All Company Images ${moment(new Date()).format(
          "DD.MM.YYYY HH.mm.ss"
        )}.zip`
        document.body.appendChild(link)
        link.click()
        setLoading(false)
        getTableData(null)
        document.body.removeChild(link)
      })
      .catch(error => {
        toastr.error(error?.response?.data?.Message)
        setLoading(false)
      })
  }

  const onMoveCompany = () => {
    const { recordName } = form.getFieldsValue()
    const findRecord = recordNameList.find(x => x.value === recordName)
    Http.get(
      `api/orders/SendForMultipleProduction?recordName=${findRecord.label}&categoryId=6`
    )
      .then(res => {
        if (res.success) {
          toastr.success(
            `${recordName} isimli kayıttaki siparişler üretime gönderilmiştir.`
          )
          getTableData({
            current: tableParams.current,
            pageSize: tableParams.pageSize,
          })
        } else {
          toastr.error(
            `${recordName} isimli kayıttaki siparişler üretime gönderilememiştir.`
          )
        }
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
        toastr.error(error?.response?.data?.Message)
      })
  }

  return (
    <React.Fragment>
      <style>{css}</style>

      {upsertModal.show && (
        <UpsertModal
          setUpsertModal={setUpsertModal}
          upsertModal={upsertModal}
          getTableData={getTableData}
          setLoading={setLoading}
          orderStatus={orderStatus}
          tableParams={tableParams}
        />
      )}

      {orderDetails.show && (
        <OrderDetails
          setModal={setOrderDetails}
          modal={orderDetails}
          getTableData={getTableData}
          setLoading={setLoading}
          loading={loading}
          tableParams={tableParams}
        />
      )}

      <div className="page-content mb-3">
        <Container fluid>
          <Card
            title="Apparel List"
            hoverable
            extra={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                {/* company admin ve ya worker */}
                {JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 1 ||
                JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 7 ? (
                  <Row>
                    <Col
                      span={24}
                      className="d-flex align-items-center justify-content-end"
                      style={{ columnGap: 15 }}
                    >
                      {products.length > 0 && (
                        <Tooltip
                          placement="top"
                          title="Tüm Şirketlerin Tasarımları İndir"
                        >
                          <Button
                            type="button"
                            className="btn btn_tertiary d-flex align-items-center"
                            icon={<DownloadOutlined />}
                            onClick={() => {
                              getAllImages()
                            }}
                          >
                            Tüm Tasarımları İndir
                          </Button>
                        </Tooltip>
                      )}
                      <Button
                        type="button"
                        visible={showRecordName ? undefined : false}
                        className="btn btn-primary d-flex align-items-center "
                        icon={<DownloadOutlined />}
                        onClick={() => {
                          !showRecordName && getImages()
                        }}
                      >
                        Download Pdf
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col
                      span={24}
                      className="d-flex align-items-center justify-content-end gap-2"
                      style={{ columnGap: 15 }}
                    >
                      {products.filter(x => x.status === 10).length === 0 &&
                        JSON.parse(localStorage.getItem("authUserV0"))
                          ?.roleId === 1 && (
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            icon={<DownloadOutlined />}
                            onClick={() => {
                              getAllImages()
                            }}
                          >
                            Tüm Şirketlerin Tasarımları İndir
                          </Button>
                        )}
                      {products.filter(x => x.status === 10).length === 0 &&
                        JSON.parse(localStorage.getItem("authUserV0"))
                          ?.roleId === 1 &&
                        showRecordName && (
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            icon={<DownloadOutlined />}
                            onClick={() => {
                              getImages()
                            }}
                          >
                            {showRecordName} Tasarımlarını İndir
                          </Button>
                        )}

                      {JSON.parse(localStorage.getItem("authUserV0"))
                        ?.roleId === 2 &&
                        !isReadyRecord &&
                        !haveOrderBefore && (
                          <Button
                            type="button"
                            className="btn btn_tertiary d-flex align-items-center"
                            icon={<AppstoreAddOutlined />}
                            onClick={() => {
                              setUpsertModal({
                                show: true,
                                data: null,
                                recordName: showRecordName,
                              })
                            }}
                          >
                            Manuel Add Order
                          </Button>
                        )}
                      {JSON.parse(localStorage.getItem("authUserV0"))
                        ?.roleId === 2 && (
                        <Button
                          type="button"
                          className="btn btn_primary d-flex align-items-center"
                          onClick={() => {
                            navigate(`/apparel-add?maxDate=${maxDate}`)
                          }}
                          icon={<AppstoreAddOutlined />}
                        >
                          Add Order
                        </Button>
                      )}
                    </Col>
                  </Row>
                )}
              </div>
            }
          >
            <Form form={form} layout="vertical">
              <Row>
                <Col lg={2}>
                  <Form.Item label="Order No & Sku" name="orderId">
                    <Input onPressEnter={() => getTableData(null)} allowClear />
                  </Form.Item>
                </Col>
                {(JSON.parse(localStorage.getItem("authUserV0"))?.roleId ===
                  1 ||
                  JSON.parse(localStorage.getItem("authUserV0"))?.roleId ===
                    7) && (
                  <Col lg={2}>
                    <Form.Item label="Customer" name="companyId">
                      <Select
                        allowClear
                        options={companyDataList}
                        onChange={e => {
                          form.setFieldsValue({
                            orderId: "",
                            recordName: "", // recordName alanını sıfırla
                          })
                          setSelectedRecordName(null) // state içindeki record name'i de sıfırla
                          setShowRecordName("") // gösterim için olan değeri sıfırla
                          getRecordsName(e)
                        }}
                        disabled={companyDataList.length === 0}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col lg={2}>
                  <Form.Item
                    label="Record Name"
                    name="recordName"
                    rules={[
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ]}
                  >
                    <Select
                      options={recordNameList}
                      allowClear
                      disabled={recordNameList.length === 0}
                      onChange={(_, data) => {
                        console.log(data)
                        setShowRecordName(data?.value ? false : true)
                        setSelectedRecordName(data)
                        getTableData(null)
                      }}
                    />
                  </Form.Item>
                </Col>
                {/* <Col lg={2}>
                  <Form.Item label="Barcode Tabancası Deneme" name="barcode">
                    <Input
                      ref={inputRef}
                      onPressEnter={e => handleInputChange(e)}
                      disabled={!recordName ? true : false}
                      onBlur={e => handleInputBlur(e)}
                      onKeyUp={e => handleInputChange(e)}
                    />
                  </Form.Item>
                </Col> */}
                <Col
                  span={3}
                  className="d-flex align-items-center justify-content-start gap-2"
                >
                  <Button
                    type="button"
                    className="btn btn_tertiary d-flex align-items-center justify-content-start mt-1"
                    icon={<ClearOutlined />}
                    onClick={() => {
                      form.setFieldsValue({
                        orderId: "",
                        recordName: "",
                        companyId: "",
                      })
                      setProducts([])
                      JSON.parse(localStorage.getItem("authUserV0"))?.roleId ===
                        1 && setRecordNameList([])
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    type="button"
                    className="btn btn_primary d-flex align-items-center justify-content-start mt-1"
                    icon={<SearchOutlined />}
                    onClick={() => {
                      getTableData(null)
                    }}
                  >
                    Search
                  </Button>
                </Col>
                <Col
                  span={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  {JSON.parse(localStorage.getItem("authUserV0"))?.roleId ===
                    2 &&
                    !isReadyRecord && (
                      <Popconfirm
                        title="Attention!"
                        description={
                          <>
                            If you send to production, <br />
                            you will not be able to perform <br />
                            operations such as uploading csv, <br />
                            adding manual orders, etc. for today. <br />
                            Do you approve?{" "}
                          </>
                        }
                        onConfirm={() => {
                          onMoveCompany()
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          type="button"
                          className="btn btn_quinary d-flex align-items-center"
                        >
                          Send to Production
                        </Button>
                      </Popconfirm>
                    )}
                </Col>
              </Row>
            </Form>
            <Table
              bordered
              size="small"
              columns={columns}
              dataSource={products}
              pagination={tableParams}
              loading={loading}
              onChange={handleTableChange}
              rowKey={record => record.id}
              rowClassName={record =>
                record.children?.length > 0 ? "multipleRow" : ""
              }
            />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OrderList
